<template>
  <!-- START : Address section per group -->
  <div>
    <!-- Address section - street1 -->
    <WCFormGroup :field="$v.profileAddress.street1" v-if="address.street1">
      <WCLabel :for="'street1' + address.did">{{ $t('streetAddress1') }}</WCLabel>
      <WCInput
        autocomplete="address-line1"
        class="bg-light form-input street1-input"
        :id="'street1' + address.did"
        @input="addressChange('street1')"
      />
      <WCValidationErrors />
    </WCFormGroup>
    <!-- Address section - street2 -->
    <WCFormGroup :field="$v.profileAddress.street2" v-if="address.street2">
      <WCLabel :for="'street2' + address.did">{{ $t('streetAddress2') }}</WCLabel>
      <WCInput
        autocomplete="address-line2"
        class="bg-light form-input street2-input"
        :id="'street2' + address.did"
        @input="addressChange('street2')"
      />
      <WCValidationErrors />
    </WCFormGroup>
    <!-- Address section - city -->
    <WCFormGroup class="wc-input" :field="$v.profileAddress.city" v-if="address.city">
      <WCLabel :for="'city' + address.did">{{ $t('city') }}</WCLabel>
      <WCInput
        autocomplete="address-level2"
        class="bg-light form-input city-input"
        :id="'city' + address.did"
        @input="addressChange('city')"
      />
      <WCValidationErrors />
    </WCFormGroup>
    <!-- Address section - state -->
    <WCFormGroup class="wc-input" :field="$v.profileAddress.state" v-if="address.state">
      <WCLabel :for="'state' + address.did">{{ $t('state') }}</WCLabel>
      <WCInput
        autocomplete="address-level1"
        class="bg-light form-input state-input"
        :id="'state' + address.did"
        @input="addressChange('state')"
      />
      <WCValidationErrors />
    </WCFormGroup>
    <!-- Address section - postal -->
    <WCFormGroup class="wc-input" :field="$v.profileAddress.postal" v-if="address.postal">
      <WCLabel :for="'postal' + address.did">{{ $t('zipCode') }}</WCLabel>
      <WCInput
        autocomplete="postal-code"
        class="bg-light form-input postal-input"
        :id="'postal' + address.did"
        @input="addressChange('postal')"
      />
      <WCValidationErrors />
    </WCFormGroup>
    <!-- Address section - country -->
    <WCFormGroup class="wc-input" :field="$v.profileAddress.country" v-if="address.country">
      <WCLabel :for="'country' + address.did">{{ $t('country') }}</WCLabel>
      <WCInput
        autocomplete="country"
        class="bg-light form-input country-input"
        :id="'country' + address.did"
        @input="addressChange('country')"
      />
      <WCValidationErrors />
    </WCFormGroup>
  </div>
  <!-- END : Address section per group -->
</template>
<script>
import WCLabel from '@/modules/forms/components/WCLabel/WCLabel.vue';
import WCFormGroup from '@/modules/forms/components/WCFormGroup/WCFormGroup.vue';
import WCInput from '@/modules/forms/components/WCInput/WCInput.vue';
import { maxLength, required } from 'vuelidate/lib/validators';
import WCValidationErrors from '@/modules/forms/components/WCValidationErrors/WCValidationErrors.vue';
import { ACCOUNT_SETTINGS_OPTIONS } from '@/constants/AppConstants';

export default {
  name: 'WCAccountSettingsAddressInput',
  components: { WCFormGroup, WCInput, WCValidationErrors, WCLabel },
  emits: ['input', 'update:valid'],
  props: {
    address: {
      type: Object,
    },
    did: {
      type: String,
    },
  },
  data() {
    return {
      profileAddress: {
        street1: this.address.street1 && this.address.street1.value,
        street2: this.address.street2 && this.address.street2.value,
        postal: this.address.postal && this.address.postal.value,
        city: this.address.city && this.address.city.value,
        state: this.address.state && this.address.state.value,
        country: this.address.country && this.address.country.value,
      },
    };
  },
  mounted() {
    this.formUpdateValid();
  },
  validations() {
    return {
      profileAddress: {
        street1:
          this.address &&
          this.address.street1 &&
          this.address.street1.option === ACCOUNT_SETTINGS_OPTIONS.REQUIRED
            ? {
                required,
                maxLength: maxLength(30),
              }
            : { maxLength: maxLength(30) },
        street2:
          this.address &&
          this.address.street2 &&
          this.address.street2.option === ACCOUNT_SETTINGS_OPTIONS.REQUIRED
            ? {
                required,
                maxLength: maxLength(30),
              }
            : { maxLength: maxLength(30) },
        city:
          this.address &&
          this.address.city &&
          this.address.city.option === ACCOUNT_SETTINGS_OPTIONS.REQUIRED
            ? {
                required,
                maxLength: maxLength(20),
              }
            : { maxLength: maxLength(20) },
        state:
          this.address &&
          this.address.state &&
          this.address.state.option === ACCOUNT_SETTINGS_OPTIONS.REQUIRED
            ? {
                required,
                maxLength: maxLength(2),
              }
            : { maxLength: maxLength(2) },
        postal:
          this.address &&
          this.address.postal &&
          this.address.postal.option === ACCOUNT_SETTINGS_OPTIONS.REQUIRED
            ? {
                required,
                maxLength: maxLength(15),
              }
            : { maxLength: maxLength(15) },
        country:
          this.address &&
          this.address.country &&
          this.address.country.option === ACCOUNT_SETTINGS_OPTIONS.REQUIRED
            ? {
                required,
                maxLength: maxLength(4),
              }
            : { maxLength: maxLength(4) },
      },
    };
  },
  methods: {
    /**
     * Method to update the address object on input update
     */
    formUpdateValid() {
      this.$emit('update:valid', !this.$v.$invalid, this.did);
    },
    addressChange(entity) {
      const addrObj = {
        ...this.address,
        [entity]: { ...this.address[entity], value: this.profileAddress[entity] },
      };
      this.$emit('input', addrObj);
      this.formUpdateValid();
    },
  },
};
</script>
